export default __webpack_public_path__ + "static/media/UR_Michael.88b33cbf.png";